import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createFilter } from 'react-select';
import { domainActions, propertyCzDomainKeys } from '../../../store/domainStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Formik, Form } from 'formik';
import { getParams } from '../../common/utils';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { pick } from 'lodash';
import { searchActions, searchStatus, cuzkSearchType } from '../../../store/searchStore';
import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from "react-router"
import * as Yup from '../../common/Yup';
import BbDatePicker from '../../common/datePicker';
import BbInput from '../../styling/bbInput';
import BbRadioWrapper from '../../styling/BbRadioWrapper';
import classnames from 'classnames';
import FormMenuControl from '../../common/formMenuControl'
import Message from '../../common/message';
import SearchTip from '../../common/searchTip';
import TabLink from '../tabLink';
import { hasPermission } from '../../../store/apiWrapper';

import IconFO from '../../../img/icons/BBiconsFo';
import IconPO from '../../../img/icons/BBiconsPo';
import IconOwnershipDeed from '../../../img/icons/BBiconsNemovitostiCisloListuVlastnictvi';

const SEARCH_TYPES = { fo: "fo", po: "po", ownershipDeed: "ownershipDeed" };
const FO_SEARCH_TYPE_KEYS = {
    pin: "pin",
    nsBd: "name-surname-bd",
    pinName: "pin-name"
};
const FOSEARCH_TYPES = [
    { name: FO_SEARCH_TYPE_KEYS.pin, trKey: "PropertyCz.Search.PoFilter.Pin" },
    { name: FO_SEARCH_TYPE_KEYS.nsBd, trKey: "PropertyCz.Search.PoFilter.NameSurnameBirthDate" },
    { name: FO_SEARCH_TYPE_KEYS.pinName, trKey: "PropertyCz.Search.PoFilter.PinName" }
];

class PropertyCzSearchForm extends React.Component {
    state = {
        selected: SEARCH_TYPES.fo,
        foSearchType: FOSEARCH_TYPES[0].name,
        error: null,
        fillData: true
    }
    mounted = false;

    componentDidMount() {
        this.props.ensureDomainData(propertyCzDomainKeys.municipalities);
        this.props.ensureDomainData(propertyCzDomainKeys.cadastreUnits);
        this.mounted = true;

        if (!(hasPermission(null, "CadastreCzPhysicalPersons") || hasPermission(null, "CadastreCzExtendedRole"))) {
            this.setState({selected: SEARCH_TYPES.po});
        }
    }

    componentDidUpdate() {
        if (this.mounted && !this.hasDomainData(propertyCzDomainKeys.municipalities))
            this.props.ensureDomainData(propertyCzDomainKeys.municipalities);
        if (this.mounted && !this.hasDomainData(propertyCzDomainKeys.cadastreUnits))
            this.props.ensureDomainData(propertyCzDomainKeys.cadastreUnits);
    }

    hasDomainData = (key) => !(isNullOrUndefined(this.props.domain[key]) ||
        (isNullOrUndefined(this.props.domain[key].requestResult) || this.props.domain[key].isRequesting));

    render() {
            const params = getParams(window.location.search);
            if (!isNullOrUndefined(params)) {
                if (!isNullOrUndefined(params.companyId) && this.state.fillData)
                    this.setState({ selected: SEARCH_TYPES.po, fillData: false });
                else if ((!isNullOrUndefined(params.name) || !isNullOrUndefined(params.surname) || !isNullOrUndefined(params.birthDate)) && this.state.fillData)
                    this.setState({ selected: SEARCH_TYPES.fo, foSearchType: FO_SEARCH_TYPE_KEYS.nsBd, fillData: false });
            }

        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize={true}
                validationSchema={this.createValidationSchema()}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    companyId: isNullOrUndefined(params) || this.state.selected !== SEARCH_TYPES.po ? '' : params.companyId || '',
                    pin: "",
                    name: isNullOrUndefined(params) || this.state.selected !== SEARCH_TYPES.fo ? '' : params.name || '',
                    surname: isNullOrUndefined(params) || this.state.selected !== SEARCH_TYPES.fo ? '' : params.surname || '',
                    birthDate: isNullOrUndefined(params) || this.state.selected !== SEARCH_TYPES.fo ? '' : params.birthDate || '',
                    dataDate: "",
                    municipalityId: null,
                    cadastreUnitId: null,
                    ownershipDeedNo: ""
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false);
                    let searchData = {};
                    if (this.state.selected === SEARCH_TYPES.po) {
                        if (!isNullOrUndefined(values.companyId) && values.companyId.trim() !== "")
                            searchData.companyId = values.companyId.replace(/\s/g, '');
                    }
                    if (this.state.selected === SEARCH_TYPES.fo) {
                        if (!isNullOrUndefined(values.pin) && values.pin.trim() !== "")
                            searchData.pin = values.pin.replace("/", "");

                        if (!isNullOrUndefined(values.name) && values.name.trim() !== "")
                            searchData.name = values.name;
                        if (!isNullOrUndefined(values.surname) && values.surname.trim() !== "")
                            searchData.surname = values.surname;
                        if (!isNullOrUndefined(values.birthDate) && values.birthDate.trim() !== "")
                            searchData.birthDate = values.birthDate;
                    }
                    if (this.state.selected === SEARCH_TYPES.ownershipDeed) {
                        if (!isNullOrUndefined(values.cadastreUnitId) && values.cadastreUnitId.trim() !== "")
                            searchData.cadastreUnitId = values.cadastreUnitId;
                        if (!isNullOrUndefined(values.ownershipDeedNo) && values.ownershipDeedNo !== "")
                            searchData.ownershipDeedNo = values.ownershipDeedNo;
                    }
                    if (!isNullOrUndefined(values.dataDate) && values.dataDate.trim() !== "")
                        searchData.dataDate = values.dataDate;

                    this.props.cuzkReset(cuzkSearchType.requests);
                    this.props.cuzkInitiateRequest(searchData, () => {
                        const data = this.getSearchResult("data");

                        if (!isNullOrUndefined(data.returnValue)) {
                            this.props.history.push(`/search/property-cz/results`);
                        } else {
                            this.props.cuzkReset(cuzkSearchType.subjects);
                            if (data.isOwnershipDeed)
                                this.props.history.push(`/search/property-cz/report-ownership-deed?id=${data.requestId}`);
                            else
                                this.props.history.push(`/search/property-cz/results/${data.requestId}?isEvidence=${data.isEvidence}&isOwnershipDeed=${data.isOwnershipDeed}`);
                        }
                    })
                }}>
                {({ values, errors, resetForm, setFieldValue }) => <Form>
                    <div className="columns is-desktop">
                        <div className="column is-4-desktop tabs tabs-form-menu">
                            <FormMenuControl>
                                <ul>
                                 {(hasPermission(null, "CadastreCzPhysicalPersons") || hasPermission(null, "CadastreCzExtendedRole")) &&
                                    <TabLink type={SEARCH_TYPES.fo} selected={this.state.selected} onSelect={(value) => { 
                                            if (hasPermission(null, "CadastreCzPhysicalPersons") || hasPermission(null, "CadastreCzExtendedRole")) {
                                                this.selectSearch(value);
                                                resetForm(); 
                                            }}
                                    } icon={<IconFO className="tabs-icon" />}
                                    titleKey='Search.Common.PhysicalPerson' descriptionKey='PropertyCz.PhysicalPerson.Description' hr={true} />
                                }
                                    <TabLink type={SEARCH_TYPES.po} selected={this.state.selected} onSelect={(value) => {  this.selectSearch(value); resetForm(); }} icon={<IconPO className="tabs-icon" />}
                                        titleKey='Search.Common.Company' descriptionKey='PropertyCz.Company.Description' hr={true} />

                                    {hasPermission(null, "CadastreCzExtendedRole") &&
                                        <TabLink type={SEARCH_TYPES.ownershipDeed} selected={this.state.selected} onSelect={(value) => { 
                                                if (hasPermission(null, "CadastreCzExtendedRole")) {
                                                this.selectSearch(value);
                                                resetForm(); 
                                            }
                                        }
                                        } icon={<IconOwnershipDeed className="tabs-icon" />}
                                            titleKey='PropertySk.SearchTab.OwnershipDeed' descriptionKey='PropertySk.SearchTab.OwnershipDeed.Description' hr={false}
                                        />
                                    }
                                </ul>
                            </FormMenuControl>
                        </div>
                        <div className='column'>
                            {Object.keys(errors).length > 0 && <div className="error-container error-container-wide" style={{ paddingBottom: "0.8em", paddingTop: "1em" }}>
                                <Message type="error" message={this.props.translate("Error.InvalidParams")}>
                                    <ul style={{ listStyleType: "disc" }}>
                                        {Object.keys(errors).map(k => <li key={k} style={{ marginLeft: "3em" }}>{this.translateErrorItem(k)}</li>)}
                                    </ul>
                                </Message>
                            </div>}
                            {this.props.search && this.props.search.requests && this.props.search.requests.error && this.props.search.requests.error.exception && <div className="error-container error-container-wide" style={{ paddingBottom: "0.8em", paddingTop: "1em" }}>
                                <Message type="error" message={this.formatMessage(this.props.translate(this.props.search.requests.error.exception))} options={{ renderInnerHtml: true }} />
                            </div>}
                            {this.props.search && this.props.search.requests && this.props.search.requests.error && this.props.search.requests.error.data && this.props.search.requests.error.data.error && this.props.search.requests.error.data.error.message && <div className="error-container error-container-wide" style={{ paddingBottom: "0.8em", paddingTop: "1em" }}>
                                <Message type="error" message={this.props.translate(this.props.search.requests.error.data.error.message)} options={{ renderInnerHtml: true }} />
                            </div>}
                            {this.hasSearchTips(this.state.selected) &&
                                <SearchTip windowId={`tips_property_cz_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                            <div className='card card-special'>
                                {this.hasSearchTips(this.state.selected) &&
                                    <SearchTip windowId={`tips_property_cz_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.state.selected)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                                <div className='card-body'>
                                    <div className='columns is-centered is-multiline'>
                                        <div className="column is-12">
                                            <div className="columns is-centered">
                                                <div className="column is-12">
                                                    {this.state.selected === SEARCH_TYPES.fo && <>
                                                        <div className="columns">
                                                            <div className="bb-radio-group-wrapper">
                                                                <div className="bb-radio-group-row">
                                                                    {FOSEARCH_TYPES.map((i, j) =>
                                                                        <div className="control" key={j}>
                                                                            <BbRadioWrapper
                                                                                id={`$radio-${i.name}`}
                                                                                name={i.name}
                                                                                value={i.name}
                                                                                checked={this.state.foSearchType === i.name}
                                                                                callback={(e) => { this.foSearchTypeChanged(e); resetForm(); }}
                                                                                label={this.props.translate(i.trKey)}
                                                                            />
                                                                        </div>)}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr />
                                                        {this.renderInput("pin", "PropertyCz.Search.Pin", this.state.foSearchType !== FO_SEARCH_TYPE_KEYS.nsBd)}
                                                        {this.renderInput("name", "PropertyCz.Search.Name", this.state.foSearchType !== FO_SEARCH_TYPE_KEYS.pin, values.name)}
                                                        {this.renderInput("surname", "PropertyCz.Search.Surname", this.state.foSearchType !== FO_SEARCH_TYPE_KEYS.pin, values.surname)}
                                                        {this.renderInput("birthDate", "PropertyCz.Search.BirthDate", this.state.foSearchType === FO_SEARCH_TYPE_KEYS.nsBd,
                                                            values.birthDate, "date")}
                                                    </>}
                                                    {this.state.selected === SEARCH_TYPES.po && this.renderInput("companyId", "PropertyCz.Search.CompanyId", true, values.companyId)}
                                                    {this.state.selected === SEARCH_TYPES.ownershipDeed && this.renderOwnershipDeedInputs(values, setFieldValue)}
                                                    {this.renderInput("dataDate", "PropertyCz.Search.DataDate", true, values.dataDate, "date")}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='columns m-0 is-centered has-text-centered'>
                                        <div className='column is-narrow'>
                                            <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                                                type='submit'
                                                style={{ fontWeight: 600 }}
                                                disabled={this.getSearchResult("status") === searchStatus.requested
                                                    || (this.state.selected === SEARCH_TYPES.ownershipDeed && (!values.cadastreUnitId || !values.ownershipDeedNo))}
                                            >
                                                {this.getSearchResult("status") === searchStatus.requested ? <FontAwesomeIcon icon="cog" spin /> : <Translate id='Search.Common.Search' />}
                                            </button>
                                        </div>
                                    </div>
                                </div >
                            </div>
                        </div >
                    </div>
                </Form>}
            </Formik>
        );
    }

    renderInput = (field, labelKey, active, value = null, type = "text") => {
        switch (type) {
            case "text": return (
                <div className={classnames({ "inactive-input-font-color": !active })}>
                    <BbInput label={this.props.translate(labelKey)} name={field} type={type} placeholder={{ type: 'column' }} disabled={!active} />
                </div>
            );
            case "date": return (
                <div className={classnames({ "inactive-input-font-color": !active })}>
                    <BbInput type="custom" label={this.props.translate(labelKey)} placeholder={{ type: 'column' }}
                        custom={<BbDatePicker
                            formik={this.formRef}
                            field={field}
                            value={value}
                            formDateFormat={"YYYY-MM-DD"}
                            yearsBack={120}
                            disabled={!active}
                        />}
                    />
                </div>
            );
            default: return 0;
        };
    }

    renderOwnershipDeedInputs = (values, setFieldValue) => {
        const districtLabel = this.props.translate("PropertyCz.Search.DistrictName");
        return <>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.Municipality")} placeholder={{ type: "column" }}
                    options={this.getMunicipalities()}
                    formatOptionLabel={o => this.selectOption(o, districtLabel)}
                    filterOption={this.customFilter}
                    value={this.getMunicipalities().find(f => f.value === values.municipalityId)}
                    onChange={(e) => this.municipalityChanged(e.value, setFieldValue)}
                    selectPlaceholder={this.props.translate("PropertyCz.Search.FillUnknownKu")}
                    isClearable
                />
            </div>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertyCz.Search.CadastreUnitId")} placeholder={{ type: "column" }}
                    options={this.getCadastreUnits(values.municipalityId)}
                    formatOptionLabel={o => this.selectOption(o, districtLabel)}
                    filterOption={isNullOrUndefined(values.municipalityId) || values.municipalityId === "" ? this.customFilter : createFilter({
                        ignoreCase: true,
                        ignoreAccents: true,
                        trim: true,
                        matchFrom: 'start'
                    })}
                    value={this.getCadastreUnits().find(f => f.value === values.cadastreUnitId)}
                    onChange={(e) => this.cadastreUnitChanged(e, setFieldValue)}
                    isClearable
                />
            </div>
            <div className={classnames({ "inactive-input-font-color": isNullOrUndefined(values.cadastreUnitId) || values.cadastreUnitId === "" })}>
                <BbInput name='ownershipDeedNo' type="number" label={this.props.translate("PropertyCz.Search.OwnershipDeedNo")} placeholder={{ type: "column" }}
                    disabled={isNullOrUndefined(values.cadastreUnitId) || values.cadastreUnitId === ""} />
            </div>
        </>
    }

    selectOption = (o, districtLabel) => (
        <div style={{ display: "flex" }}>
            <span style={{ minHeight: "1em" }} size="medium">{o.value ? `${o.label} (${districtLabel.replace('%name%', o.district)}); ${o.value}` : ''}</span>
        </div>
    );

    customFilter(option, searchText) {
        if (isNullOrUndefined(searchText) || searchText === "")
            return option.data.value === "";

        var label = option.data.label.toLowerCase();
        var search = searchText.toLowerCase();
        var non_asciis = {
            "e": "[éě]",
            "r": "[ŕř]",
            "t": "ť",
            "y": "ý",
            "u": "[úů]",
            "i": "í",
            "o": "[óô]",
            "a": "á",
            "s": "š",
            "d": "ď",
            "l": "[ĺľ]",
            "z": "ž",
            "c": "č",
            "n": "ň"
        };
        for (var i in non_asciis) { label = label.replace(new RegExp(non_asciis[i], 'g'), i); }
        for (var i in non_asciis) { search = search.replace(new RegExp(non_asciis[i], 'g'), i); }

        return label.startsWith(search) ||
            option.data.value.startsWith(search);
    }

    createValidationSchema = () => {
        const pinFormat = /(^(\d\d)(\d\d)(\d\d)[\/]*(\d\d\d)(\d?)$)/i;
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const schema = {
            'companyId': Yup.string().trim().required(wrongInputMsg).matches(/\d+/, { message: wrongInputMsg }),
            'pin': Yup.string().trim().required(wrongInputMsg).matches(pinFormat, { message: wrongInputMsg }),
            'name': Yup.string().trim().required(wrongInputMsg).matches(/^[\u0041-\uFFFF]+(\s*[\u0041-\uFFFF]+)*$/, { message: wrongInputMsg }),
            'surname': Yup.string().trim().required(wrongInputMsg).matches(/^[\u0041-\uFFFF]+(\s*[\u0041-\uFFFF]+)*$/, { message: wrongInputMsg }),
            'birthDate': Yup.string().trim().required(wrongInputMsg),
            'cadastreUnitId': Yup.string().trim().required(wrongInputMsg),
            'ownershipDeedNo': Yup.string().trim().required(wrongInputMsg).matches(/\d+/, { message: wrongInputMsg })
        };

        if (this.state.selected === SEARCH_TYPES.po)
            return Yup.object().shape(pick(schema, ['companyId']));

        if (this.state.selected === SEARCH_TYPES.ownershipDeed)
            return Yup.object().shape(pick(schema, ['cadastreUnitId', 'ownershipDeedNo']));

        if (this.state.foSearchType === FO_SEARCH_TYPE_KEYS.pin)
            return Yup.object().shape(pick(schema, ['pin']))
        else if (this.state.foSearchType === FO_SEARCH_TYPE_KEYS.nsBd)
            return Yup.object().shape(pick(schema, ['name', 'surname', 'birthDate']));
        else if (this.state.foSearchType === FO_SEARCH_TYPE_KEYS.pinName)
            return Yup.object().shape(pick(schema, ['pin', 'name', 'surname']));
        else
            return Yup.object().shape({});
    }

    translateErrorItem = (item) =>
        (item === null || item === null || item.length < 1) ? null : this.props.translate(`PropertyCz.Search.${item[0].toUpperCase()}${item.slice(1)}`)

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }
    foSearchTypeChanged = (event) => this.setState({ foSearchType: event.target.value });

    getSearchResult = (field) => {
        return (isNullOrUndefined(this.props.search) || isNullOrUndefined(this.props.search[cuzkSearchType.requests]))
            ? null : this.props.search[cuzkSearchType.requests][field];
    }

    hasSearchTips(searchType) {
        switch (searchType) {
            case SEARCH_TYPES.fo:
            case SEARCH_TYPES.po:
            case SEARCH_TYPES.ownershipDeed:
                return true;
        }
        return false;
    }

    getSearchTipsModel = (searchType) => {
        switch (searchType) {
            case SEARCH_TYPES.fo:
                return { title: `${this.props.translate('Search.Common.PhysicalPerson')}`, bodyHtml: this.props.translate('SearchTips.PropertyCZ.FO.Body') };
            case SEARCH_TYPES.po:
                return { title: `${this.props.translate('Search.Common.Company')}`, bodyHtml: this.props.translate('SearchTips.PropertyCZ.PO.Body') };
            case SEARCH_TYPES.ownershipDeed:
                return { title: `${this.props.translate('PropertyCz.Search.OwnershipDeedNo')}`, bodyHtml: this.props.translate('SearchTips.PropertyCZ.OwnershipDeed.Body') };
        }
        return undefined;
    }

    getMunicipalities = () => {
        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertyCzDomainKeys.municipalities))
            return [defaultChoice];

        const municipalities = this.props.domain[propertyCzDomainKeys.municipalities].requestResult;
        return [defaultChoice, ...municipalities.map(r => ({ key: r.value, value: r.value, label: r.label, district: r.shortening }))];
    }

    getCadastreUnits = (municipalityId) => {
        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertyCzDomainKeys.cadastreUnits))
            return [defaultChoice];

        const cadastreUnits = (isNullOrUndefined(municipalityId) || municipalityId === "") ?
            this.props.domain[propertyCzDomainKeys.cadastreUnits].requestResult :
            this.props.domain[propertyCzDomainKeys.cadastreUnits].requestResult.filter(f => f.parentId === municipalityId);
        return [defaultChoice, ...cadastreUnits.map(r => ({ key: r.value, value: r.value, label: r.label, district: r.shortening, parentId: r.parentId }))];
    }

    municipalityChanged = (value, setFieldValue) => {
        setFieldValue('municipalityId', value);
        setFieldValue('cadastreUnitId', "");
    }

    cadastreUnitChanged = (option, setFieldValue) => {
        setFieldValue('cadastreUnitId', option.value);
        if (!isNullOrUndefined(option.parentId) && option.parentId !== "")
            setFieldValue('municipalityId', option.parentId);
    }

    formatMessage = (message) => {
        if (this.props && this.props.search && this.props.search.requests && this.props.search.requests.error && this.props.search.requests.error.exceptionData) {
            message = message.replaceAll("${min}", "5.9.2001");

            if (this.props.search.requests.error.exceptionData.max)
                message = message.replaceAll("${max}", this.props.search.requests.error.exceptionData.max);
        }
        return message;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: state.search.cuzk, domain: state.domain }),
    dispatch => bindActionCreators({ ...searchActions, ...windowActions, ...domainActions }, dispatch),
)(PropertyCzSearchForm)));
